"use client";

import cnBind from "classnames/bind";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/shared/auth/AuthContext";
import { userHasStaffRole } from "@/shared/auth/staffAccess";

import styles from "./HeaderAuth.module.scss";

const cx = cnBind.bind(styles);

type HeaderAuthProps = {
    variant?: "default" | "compact";
    className?: string;
};

export const HeaderAuth = ({ variant = "default", className }: HeaderAuthProps) => {
    const { t } = useTranslation("common");
    const { isReady, isAuthenticated, user, logout } = useAuth();

    if (!isReady) {
        return <div className={cx("root", variant === "compact" && "compact", className)} aria-hidden />;
    }

    if (isAuthenticated && user) {
        const staff = userHasStaffRole(user);
        return (
            <div className={cx("root", variant === "compact" && "compact", className)}>
                <span className={cx("user")} title={user.email}>
                    {user.email}
                </span>
                <Link href={staff ? "/admin" : "/cabinet"} className={cx("login")}>
                    {staff ? t("settings.header.admin") : t("settings.header.cabinet")}
                </Link>
                <button type="button" className={cx("register")} onClick={() => void logout()}>
                    {t("settings.header.logout")}
                </button>
            </div>
        );
    }

    return (
        <div className={cx("root", variant === "compact" && "compact", className)}>
            <Link href="/auth?tab=login&next=/cabinet" className={cx("login")}>
                {t("settings.header.login")}
            </Link>
            <Link href="/auth?tab=register&next=/cabinet" className={cx("register")}>
                {t("settings.header.register")}
            </Link>
        </div>
    );
};
